import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { fontMap } = theme();

  return StyleSheet.create({
    textBold: {
      fontFamily: fontMap.Action,
    },
  });
};

export { style };
